import { Component, OnInit } from '@angular/core';

import { DynamicFormCommonConfig } from 'zr-dynamic-form/dynamic-form-common';

import { AbstractPropertyEditorBase } from '../../types/property-editor.types';

@Component({
  selector: 'df-text-box-property-editor',
  templateUrl: './text-box-property-editor.component.html',
  styleUrls: ['./text-box-property-editor.component.css']
})
export class TextBoxPropertyEditorComponent extends AbstractPropertyEditorBase implements OnInit {
  constructor(private commonConfig: DynamicFormCommonConfig) {
    super();
  }

  ngOnInit() {}

  afterControlValueInit() {
    if (this.settings) {
      if (this.settings.maxlength === undefined) {
        this.settings.maxlength = 5;
      }
    }
  }

  afterSetControlValue(value: any) {
    if (this.settings && this.settings.changeType === 'blur') {
    } else {
      super.afterSetControlValue(value);
    }
  }

  inputEnd() {
    if (!this.settings) {
      return;
    }

    if (this.settings.changeType === 'blur') {
      this.valueChange.emit(this.value);
      return;
    }
  }
}
